import script from "./ExamGoalReturnButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamGoalReturnButton.vue?vue&type=script&setup=true&lang=ts"

import "./ExamGoalReturnButton.vue?vue&type=style&index=0&id=ff6f24fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff6f24fc"]])

export default __exports__